import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import Eyebrow from './page/Eyebrow';
import { tie } from './page/typography';

/**
 * Заголовок розділу на внутрішній сторінці.
 *
 * До цього кожна сторінка складала його сама: десь h2 був font-black, десь
 * font-bold, десь риска стояла під заголовком, десь її не було, а
 * посилання «Перелік послуг →» праворуч жило лише на сторінці питань.
 * Дрібниці, але разом вони й давали відчуття, що сторінки зібрані різними
 * руками. Тепер один компонент: заголовок, риска, за потреби — абзац під
 * ним і посилання праворуч.
 *
 * `caption` — підпис над заголовком, як на сторінці контактів. Із ним риска
 * під заголовком не малюється: дві риски на один заголовок — це вже
 * орнамент, а не ієрархія.
 *
 * `captionTone` — тон підпису ('teal' | 'amber', див. Eyebrow): бурштиновий
 * для блоків-попереджень.
 *
 * Розмір навмисно менший за заголовок секції головної (SectionHeading):
 * на внутрішній сторінці над усім стоїть h1 у банері, і h2 має бути
 * помітно меншим за нього.
 */
const SectionTitle = ({ title, caption, captionTone, description, link, id, as: Tag = 'h2', className = '' }) => (
  <div className={`mb-7 ${className}`}>
    {caption && <Eyebrow tone={captionTone} className="mb-3">{caption}</Eyebrow>}
    {/* Риска — під самим заголовком, а не під усім рядком: на телефоні
        посилання переноситься вниз, і риска опинялася під ним. */}
    <div className="flex flex-wrap items-end justify-between gap-x-6 gap-y-3">
      <div>
        <Tag id={id} className="text-2xl lg:text-3xl font-extrabold font-display text-slate-900 leading-tight text-balance">
          {tie(title)}
        </Tag>
        {!caption && <div className="w-12 h-1 bg-gradient-to-r from-teal-500 to-sky-400 mt-2"></div>}
      </div>
      {/* pb-3 — висота риски з відступом: посилання стоїть на рівні низу
          заголовка, а не риски. py-3 -my-3: рядок той самий, а влучити
          пальцем легше — ціль 44px. */}
      {link && (
        <div className={caption ? '' : 'pb-3'}>
          <Link
            to={link.to}
            className="inline-flex items-center gap-2 py-3 -my-3 text-sm font-semibold text-teal-700 hover:text-teal-800 transition-colors duration-200"
          >
            {link.label}
            <Icon name="fa-arrow-right" />
          </Link>
        </div>
      )}
    </div>
    {description && (
      <p className={`${caption ? 'mt-3' : 'mt-4'} max-w-3xl text-base lg:text-lg leading-relaxed text-slate-600`}>{tie(description)}</p>
    )}
  </div>
);

export default SectionTitle;
